import type { HealthStatus, Severity } from '@shared/contract';
import { STATUS_GLYPH } from '@/lib/format';

/**
 * Status chip. Carries a glyph as well as colour — a red/green-only wall
 * display is unreadable for the ~8% of men with a colour vision deficiency.
 */
export function StatusChip({
  status,
  label,
  muted = false,
}: {
  status: HealthStatus;
  label?: string;
  muted?: boolean;
}) {
  return (
    <span className={`chip chip--${muted ? 'muted' : status}`}>
      <span className="chip__glyph" aria-hidden="true">
        {STATUS_GLYPH[status]}
      </span>
      {label ?? status}
    </span>
  );
}

export function SeverityChip({ severity, acked = false }: { severity: Severity; acked?: boolean }) {
  return (
    <span className={`sev-chip ${severity}${acked ? ' is-acked' : ''}`} title={acked ? 'Acknowledged' : undefined}>
      {severity}
    </span>
  );
}

export function StatePill({ state }: { state: 'open' | 'acked' | 'resolved' }) {
  return <span className={`pill is-${state}`}>{state}</span>;
}
